
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { StorageAccess, Permissions_allowsInStorage, Permission, Permissions_has } from "../../Shared/Roles.js";
import { usePermissions } from "../../UserPermissions.js";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { choose, isEmpty, tryFind, ofArray, map as map_1, toArray, singleton, contains, filter, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { safeHash, equals, createObj, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { NewToolModalView } from "../../Tools/Tool/Form/View.js";
import { value as value_21, defaultArg, map, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { SetId__get_unwrap, LabelId, BusinessUnitId__get_unwrap, FormState__getValidation, StorageId as StorageId_1 } from "../../Shared/Shared.js";
import { SelectToolModal } from "../Dialog/SelectToolModal.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { TableControl$1, Table } from "../../Widgets/Table/Table.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import Shipment_Add from "../../../public/assets/icons/Shipment_Add.svg";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { concat, isNullOrWhiteSpace, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { NewCategoryDialog } from "../../Widgets/Dialogs/NewCategoryDialog.js";
import { Msg } from "./Types.js";
import { AreaAnchorMenu } from "../../Widgets/AnchorMenu.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { InformationAlert, ErrorAlert } from "../../Components/Alert.js";
import { FormMultipleImageSection, FormSection } from "../../Widgets/FormSection.js";
import { CurrencyInput, Input, AutoSuggestInput } from "../../Components/Input.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { BusinessUnitSelect } from "../../Widgets/BusinessUnitSelect.js";
import { unwrapStorageId } from "../../Shared/Helper.js";
import { MultiSelectWithColor, Select } from "../../Components/Select.js";
import { Storage__get_DisplayName } from "../../Shared/Storage.js";
import { TextArea } from "../../Components/TextArea.js";
import { Hierarchy_getAllCategoryIdsInHierarchy, Hierarchy_getDisplayName, Hierarchy_buildTreeOrderedList, Hierarchy_keepDeepestCategories } from "../../Shared/Category.js";
import { map as map_2 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { Button, TextButton } from "../../Components/Button.js";
import { QrCodeTable } from "../../Widgets/Tables/QrCodeTable.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { NewInventoryCustomProperties } from "../../Widgets/CustomProperties.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initCopySetView, initNewSetView, update as update_1, initEditView } from "./State.js";
import Arrow_Left_1 from "../../../public/assets/icons/Arrow_Left_1.svg";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { getQueryParams } from "../../Common.js";
import { PageHeader } from "../../Components/Text.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function ToolTable(props) {
    let Title, TableRows, Options;
    const t = useTranslation()[0];
    const canCreateInventory = Permissions_has(usePermissions(), new Permission(1, []));
    const patternInput_1 = reactApi.useState(empty());
    const setSelectedToolIds = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsCreateToolDialogOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const setIsAddToolModalOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setIsRemoveToolIdDialogOpen = patternInput_4[1];
    const assignedTools = filter((tool) => contains(tool.ToolId, props.ToolIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), props.Tools);
    const xs = [createElement(NewToolModalView, {
        BusinessUnitId: unwrap(props.SelectedBusinessUnitId),
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: patternInput_2[0],
        IsSelectedStorageIdNeeded: true,
        OnClose: () => {
            setIsCreateToolDialogOpen(false);
        },
        OnSuccessCallback: (toolId) => {
            setIsCreateToolDialogOpen(false);
            props.OnAssignToolId(singleton(toolId));
            props.FetchTools();
        },
        StorageId: unwrap(map((storageId) => (new StorageId_1(parse(storageId))), props.SelectedStorageId)),
        UserData: props.UserData,
    }), createElement(SelectToolModal, {
        AssignedReceiverName: "",
        IsOpen: patternInput_3[0],
        OnAddToolIds: (toolIds) => {
            props.OnAssignToolId(toolIds);
            setIsAddToolModalOpen(false);
        },
        OnClose: () => {
            setIsAddToolModalOpen(false);
        },
        SelectedStorageId: unwrap(props.SelectedStorageId),
        Tools: filter((tool_1) => !contains(tool_1.ToolId, props.ToolIds, {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: (x_1) => (stringHash(x_1) | 0),
        }), props.Tools),
    }), createElement(ConfirmationDialog, (Title = t("set.tool_remove_dialog.title"), {
        Description: t("set.tool_remove_dialog.description"),
        IsOpen: patternInput_4[0],
        OnClose: () => {
            setIsRemoveToolIdDialogOpen(false);
            setSelectedToolIds(empty());
        },
        OnConfirm: () => {
            props.OnRemoveToolId(patternInput_1[0]);
            setIsRemoveToolIdDialogOpen(false);
            setSelectedToolIds(empty());
        },
        Title: Title,
    })), createElement(Table, (TableRows = toArray(assignedTools), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: false,
        CustomTableFilters: false,
        DefaultSortColumn: ["qrCodeId", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        RowSelection: "multiRow",
        SaveTableConfiguration: false,
    }, {
        ColumnDefinitions: [new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (dto) => (new CellContent(6, [dto.ImageUrl])), "none", "image"), new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.DisplayName])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_1) => (new CellContent(0, [row_1.InventoryNumber])), "text", "text"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_2) => (new CellContent(0, [row_2.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_3) => (new CellContent(0, [row_3.Model])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_4) => (new CellContent(0, [row_4.SerialNumber])), "text", "text")],
        Controls: canCreateInventory ? ofArray([new TableControl$1(t("general.add"), Shipment_Add(), (_arg_4) => {
            setIsAddToolModalOpen(true);
        }, false, false, "add-tool"), new TableControl$1(t("tool.create_new_tool"), Shipment_Add(), (_arg_5) => {
            setIsCreateToolDialogOpen(true);
        }, false, false, "create-tool-tool-table"), new TableControl$1(t("general.remove"), Recycle_Bin_1(), (tools) => {
            setSelectedToolIds(map_1((tool_2) => tool_2.ToolId, tools));
            setIsRemoveToolIdDialogOpen(true);
        }, true, false, "set-form-remove-tool")]) : empty(),
        Options: Options,
        TableKey: "not-defined-table",
        TableRows: TableRows,
    })))];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function SetForm(props) {
    let elems_5, elems, elems_4, elems_3;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const patternInput_1 = reactApi.useState("master_data");
    const patternInput_2 = reactApi.useState(false);
    const setIsNewCateogoryDialogOpen = patternInput_2[1];
    const isCommercialDataVisible = Permissions_has(permissions, new Permission(31, []));
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,1fr]", "mt-12"])], (elems_5 = [createElement(NewCategoryDialog, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsNewCateogoryDialogOpen(false);
            props.Dispatch(new Msg(26, []));
        },
    }), reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => append(singleton_1({
            Id: "master_data",
            Label: t("general.master_data"),
        }), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = props.State.FormKind, (matchValue_1.tag === 2) ? append(singleton_1({
                Id: "tools",
                Label: t("general.tool"),
            }), delay(() => singleton_1({
                Id: "qr_codes",
                Label: t("general.qr_codes"),
            }))) : ((matchValue_1.tag === 1) ? (empty_1()) : append(singleton_1({
                Id: "tools",
                Label: t("general.tool"),
            }), delay(() => singleton_1({
                Id: "qr_codes",
                Label: t("general.qr_codes"),
            }))))), delay(() => append(singleton_1({
                Id: "appointments",
                Label: t("general.appointments"),
            }), delay(() => append(isCommercialDataVisible ? singleton_1({
                Id: "commercial_data",
                Label: t("tool.commercial_data"),
            }) : empty_1(), delay(() => (props.IsCustomPropertiesEnabled ? singleton_1({
                Id: "custom_properties",
                Label: t("tool.custom_properties"),
            }) : empty_1())))))));
        })))),
        OnSelectAnchor: patternInput_1[1],
        SelectedAnchor: patternInput_1[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "max-w-5xl"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-9"])], (elems_3 = toList(delay(() => {
        let matchValue_2;
        return append((matchValue_2 = FormState__getValidation(props.FormState, t, "global"), (matchValue_2 == null) ? (empty_1()) : singleton_1(createElement(ErrorAlert, {
            Label: matchValue_2,
        }))), delay(() => append(singleton_1(createElement(InformationAlert, {
            Label: t("set.form.create_information"),
        })), delay(() => {
            let Header;
            return append(singleton_1(createElement(FormSection, (Header = t("general.master_data"), {
                Content: toList(delay(() => append(!props.IsEdit ? singleton_1(createElement(FormMultipleImageSection, {
                    ComponentState: componentState,
                    SelectedFiles: props.SetImages,
                    SetSelectedFile: (files) => {
                        props.Dispatch(new Msg(19, [files]));
                    },
                })) : empty_1(), delay(() => {
                    let dependencies_1;
                    return append(singleton_1((dependencies_1 = [props.Set.MasterData.Manufacturer, props.State.Manufacturers, props.State.IsValidated, componentState], reactApi.useMemo(() => createElement(AutoSuggestInput, {
                        ComponentState: componentState,
                        Label: t("tool.manufacturer"),
                        OnChange: (arg) => {
                            props.Dispatch(new Msg(0, [arg]));
                        },
                        Suggestions: props.State.Manufacturers,
                        TestId: "create-tool-form-manufacturer",
                        Value: props.Set.MasterData.Manufacturer,
                    }), dependencies_1))), delay(() => append(singleton_1(createElement(Input, {
                        ComponentState: componentState,
                        Label: t("tool.model"),
                        OnChange: (arg_1) => {
                            props.Dispatch(new Msg(2, [arg_1]));
                        },
                        TestId: "create-tool-form-model",
                        Value: props.Set.MasterData.Model,
                    })), delay(() => append(singleton_1(createElement(Input, {
                        ComponentState: componentState,
                        Label: t("tool.serial_number"),
                        OnChange: (arg_2) => {
                            props.Dispatch(new Msg(3, [arg_2]));
                        },
                        TestId: "create-tool-form-serial-number",
                        Value: props.Set.MasterData.SerialNumber,
                    })), delay(() => append(singleton_1(createElement(Input, {
                        ComponentState: componentState,
                        Label: t("tool.displayname"),
                        OnChange: (arg_3) => {
                            props.Dispatch(new Msg(1, [arg_3]));
                        },
                        TestId: "create-tool-form-display-name",
                        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
                        Value: props.Set.MasterData.Name,
                    })), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? ((props.AccountSettings.BusinessUnitsEnabled && !props.IsEdit) ? singleton_1(createElement(BusinessUnitSelect, {
                        BusinessUnits: props.BusinessUnits,
                        FormState: props.FormState,
                        OnChange: (value_5) => {
                            props.Dispatch(new Msg(20, [value_5]));
                        },
                        SelectedBusinessUnitId: unwrap(props.Set.BusinessUnitId),
                    })) : empty_1()) : empty_1(), delay(() => {
                        let Label_4, Value_4;
                        return append(singleton_1(createElement(Input, (Label_4 = t("tool.inventory_number"), (Value_4 = ((props.CustomerConfiguration.InventoryConfiguration.InventoryNumberAutomaticIncrease && isNullOrWhiteSpace(props.Set.MasterData.InventoryNumber)) ? t("settings.inventory.inventory_number_placeholder") : props.Set.MasterData.InventoryNumber), {
                            ComponentState: props.CustomerConfiguration.InventoryConfiguration.InventoryNumberAutomaticIncrease ? "disabled" : componentState,
                            Label: unwrap(Label_4),
                            OnChange: (arg_4) => {
                                props.Dispatch(new Msg(4, [arg_4]));
                            },
                            TestId: "create-tool-form-inventory-number",
                            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "inventoryNumber")),
                            Value: Value_4,
                        })))), delay(() => {
                            let Label_5, Options, NoOptionsMessage, Value_6;
                            const storage = tryFind((s) => (unwrapStorageId(s.Id) === props.Set.LocationInformation.StorageId), props.Storages);
                            return append(!props.IsEdit ? singleton_1(createElement(Select, (Label_5 = t("general.storage"), (Options = map_1((storage_1) => ({
                                label: Storage__get_DisplayName(storage_1),
                                value: unwrapStorageId(storage_1.Id),
                            }), filter((s_2) => {
                                const matchValue_3 = props.Set.BusinessUnitId;
                                if (matchValue_3 == null) {
                                    return true;
                                }
                                else {
                                    const businessUnitId = matchValue_3;
                                    return defaultArg(map((id) => (id === businessUnitId), map(BusinessUnitId__get_unwrap, s_2.BusinessUnitId)), false);
                                }
                            }, filter((s_1) => Permissions_allowsInStorage(permissions, new Permission(1, []), props.UserData.UserId, unwrapStorageId(s_1.Id), s_1.AssignedUserIds), props.Storages))), (NoOptionsMessage = t("tool.no_storage_found"), (Value_6 = ((storage == null) ? undefined : {
                                label: Storage__get_DisplayName(storage),
                                value: props.Set.LocationInformation.StorageId,
                            }), {
                                ComponentState: (componentState === "enabled") ? (isEmpty(props.Set.AssignedToolIds) ? componentState : "disabled") : componentState,
                                IsClearable: false,
                                Label: unwrap(Label_5),
                                NoOptionsMessage: NoOptionsMessage,
                                OnChange: (s_3) => {
                                    props.Dispatch(new Msg(5, [value_21(s_3)]));
                                },
                                Options: Options,
                                PlaceholderKey: "",
                                TestId: "create-tool-form-select",
                                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "storage")),
                                Value: unwrap(Value_6),
                            })))))) : empty_1(), delay(() => append(!isEmpty(props.Set.AssignedToolIds) ? singleton_1(createElement(InformationAlert, {
                                Label: t("set.form.storage_selected_information"),
                            })) : empty_1(), delay(() => append(singleton_1(createElement(Input, {
                                ComponentState: componentState,
                                Label: t("tool.storage_space"),
                                OnChange: (arg_5) => {
                                    props.Dispatch(new Msg(6, [arg_5]));
                                },
                                TestId: "create-tool-form-storage-space",
                                Value: props.Set.LocationInformation.StorageSpace,
                            })), delay(() => append(singleton_1(createElement(TextArea, {
                                ComponentState: componentState,
                                Label: t("general.comment"),
                                OnChange: (arg_6) => {
                                    props.Dispatch(new Msg(7, [arg_6]));
                                },
                                TestId: "create-tool-form-comment",
                                Value: props.Set.MasterData.Comment,
                            })), delay(() => {
                                let elems_1;
                                return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], ["data-test-id", "tool-form-categories"], (elems_1 = toList(delay(() => {
                                    const deepestSelectedIds = Hierarchy_keepDeepestCategories(props.Labels, map_1((id_1) => (new LabelId(parse(id_1))), props.Set.LabelIds));
                                    const treeOptions = map_1((tupledArg) => {
                                        const l = tupledArg[0];
                                        return {
                                            color: l.ColorHex,
                                            label: concat(Array((tupledArg[1] * 4) + 1).join(" "), ...l.Name),
                                            value: l.Id,
                                        };
                                    }, Hierarchy_buildTreeOrderedList(props.Labels));
                                    return append(singleton_1(createElement(MultiSelectWithColor, {
                                        ComponentState: componentState,
                                        IsClearable: true,
                                        Label: t("tool.label"),
                                        NoOptionsMessage: "",
                                        OnChange: (options) => {
                                            props.Dispatch(new Msg(8, [ofArray(map_2((o_1) => o_1.value, defaultArg(options, [])))]));
                                        },
                                        Options: filter((o) => !contains(o.value, deepestSelectedIds, {
                                            Equals: equals,
                                            GetHashCode: (x) => (safeHash(x) | 0),
                                        }), treeOptions),
                                        PlaceholderKey: "",
                                        TestId: "set-category-select",
                                        Value: map_1((l_2) => ({
                                            color: l_2.ColorHex,
                                            label: Hierarchy_getDisplayName(props.Labels, l_2),
                                            value: l_2.Id,
                                        }), choose((id_2) => tryFind((l_1) => equals(l_1.Id, id_2), props.Labels), deepestSelectedIds)),
                                    })), delay(() => singleton_1(createElement(TextButton, {
                                        ComponentState: componentState,
                                        Label: t("settings.create_new_label"),
                                        OnClick: () => {
                                            setIsNewCateogoryDialogOpen(true);
                                        },
                                        TestId: "add-new-category-button",
                                        Variant: "default",
                                    }))));
                                })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                            }))))))));
                        }));
                    }))))))))));
                })))),
                Header: Header,
                Id: "master_data",
            }))), delay(() => {
                let matchValue_4, Header_1;
                return append((matchValue_4 = props.State.FormKind, (matchValue_4.tag === 2) ? singleton_1(createElement(FormSection, (Header_1 = t("general.tool"), {
                    Content: singleton(createElement(ToolTable, {
                        CustomerConfiguration: props.CustomerConfiguration,
                        FetchTools: () => {
                            props.Dispatch(new Msg(27, []));
                        },
                        OnAssignToolId: (arg_7) => {
                            props.Dispatch(new Msg(17, [arg_7]));
                        },
                        OnRemoveToolId: (arg_8) => {
                            props.Dispatch(new Msg(18, [arg_8]));
                        },
                        SelectedBusinessUnitId: unwrap(props.Set.BusinessUnitId),
                        SelectedStorageId: unwrap((props.Set.LocationInformation.StorageId === "") ? undefined : props.Set.LocationInformation.StorageId),
                        ToolIds: props.Set.AssignedToolIds,
                        Tools: props.Tools,
                        UserData: props.UserData,
                    })),
                    Header: Header_1,
                    Id: "tools",
                }))) : ((matchValue_4.tag === 1) ? (empty_1()) : singleton_1(createElement(FormSection, (Header_1 = t("general.tool"), {
                    Content: singleton(createElement(ToolTable, {
                        CustomerConfiguration: props.CustomerConfiguration,
                        FetchTools: () => {
                            props.Dispatch(new Msg(27, []));
                        },
                        OnAssignToolId: (arg_7) => {
                            props.Dispatch(new Msg(17, [arg_7]));
                        },
                        OnRemoveToolId: (arg_8) => {
                            props.Dispatch(new Msg(18, [arg_8]));
                        },
                        SelectedBusinessUnitId: unwrap(props.Set.BusinessUnitId),
                        SelectedStorageId: unwrap((props.Set.LocationInformation.StorageId === "") ? undefined : props.Set.LocationInformation.StorageId),
                        ToolIds: props.Set.AssignedToolIds,
                        Tools: props.Tools,
                        UserData: props.UserData,
                    })),
                    Header: Header_1,
                    Id: "tools",
                }))))), delay(() => {
                    let matchValue_5, Header_2;
                    return append((matchValue_5 = props.State.FormKind, (matchValue_5.tag === 2) ? singleton_1(createElement(FormSection, (Header_2 = t("general.qr_codes"), {
                        Content: singleton(createElement(QrCodeTable, {
                            OnAssignQrCode: (arg_9) => {
                                props.Dispatch(new Msg(10, [arg_9]));
                            },
                            OnDeleteQrCodes: (arg_10) => {
                                props.Dispatch(new Msg(28, [arg_10]));
                            },
                            QrCodes: props.Set.QRCodeIds,
                            Storage: unwrap(map((s_5) => (new StorageAccess(unwrapStorageId(s_5.Id), s_5.AssignedUserIds)), tryFind((s_4) => (unwrapStorageId(s_4.Id) === props.Set.LocationInformation.StorageId), props.Storages))),
                            UserData: props.UserData,
                        })),
                        Header: Header_2,
                        Id: "qr_codes",
                    }))) : ((matchValue_5.tag === 1) ? (empty_1()) : singleton_1(createElement(FormSection, (Header_2 = t("general.qr_codes"), {
                        Content: singleton(createElement(QrCodeTable, {
                            OnAssignQrCode: (arg_9) => {
                                props.Dispatch(new Msg(10, [arg_9]));
                            },
                            OnDeleteQrCodes: (arg_10) => {
                                props.Dispatch(new Msg(28, [arg_10]));
                            },
                            QrCodes: props.Set.QRCodeIds,
                            Storage: unwrap(map((s_5) => (new StorageAccess(unwrapStorageId(s_5.Id), s_5.AssignedUserIds)), tryFind((s_4) => (unwrapStorageId(s_4.Id) === props.Set.LocationInformation.StorageId), props.Storages))),
                            UserData: props.UserData,
                        })),
                        Header: Header_2,
                        Id: "qr_codes",
                    }))))), delay(() => {
                        let Header_3;
                        return append(isCommercialDataVisible ? singleton_1(createElement(FormSection, (Header_3 = t("tool.commercial_data"), {
                            Content: ofArray([createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.supplier"),
                                OnChange: (arg_11) => {
                                    props.Dispatch(new Msg(11, [arg_11]));
                                },
                                TestId: "tool-form-supplier",
                                Value: props.Set.MasterData.CommercialData.Supplier,
                            }), createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.supplier_article_number"),
                                OnChange: (arg_12) => {
                                    props.Dispatch(new Msg(12, [arg_12]));
                                },
                                TestId: "tool-form-article-number",
                                Value: props.Set.MasterData.CommercialData.SupplierArticleNumber,
                            }), createElement(CurrencyInput, {
                                ComponentState: componentState,
                                Currency: props.CustomerConfiguration.Currency,
                                Label: t("general.purchase_price"),
                                OnChange: (price) => {
                                    props.Dispatch(new Msg(13, [price]));
                                },
                                TestId: "tool-form-purchase-price",
                                Value: unwrap(props.Set.MasterData.CommercialData.PurchasePrice),
                            }), createElement(DatePicker, {
                                ComponentState: componentState,
                                IsClearable: true,
                                Label: t("general.purchase_date"),
                                OnChange: (date) => {
                                    props.Dispatch(new Msg(14, [date]));
                                },
                                TestId: "tool-form-purchase-date",
                                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "purchaseDate")),
                                Value: unwrap(props.PurchaseDate),
                            }), createElement(DatePicker, {
                                ComponentState: componentState,
                                IsClearable: true,
                                Label: t("general.gurantee_date"),
                                OnChange: (date_1) => {
                                    props.Dispatch(new Msg(15, [date_1]));
                                },
                                TestId: "tool-form-gurantee-date",
                                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "warrantyDate")),
                                Value: unwrap(props.WarrantyDate),
                            }), createElement(TextArea, {
                                ComponentState: componentState,
                                Label: t("general.comment"),
                                OnChange: (arg_13) => {
                                    props.Dispatch(new Msg(16, [arg_13]));
                                },
                                TestId: "tool-form-commercial-data-comment",
                                Value: props.Set.MasterData.CommercialData.Comment,
                            })]),
                            Header: Header_3,
                            Id: "commercial_data",
                        }))) : empty_1(), delay(() => {
                            let Header_4;
                            return append(props.IsCustomPropertiesEnabled ? singleton_1(createElement(FormSection, (Header_4 = t("tool.custom_properties"), {
                                Content: singleton(createElement(NewInventoryCustomProperties, {
                                    Currency: props.CustomerConfiguration.Currency,
                                    CustomProperties: props.Set.MasterData.CustomProperties,
                                    FormState: props.FormState,
                                    LabelIds: Hierarchy_getAllCategoryIdsInHierarchy(props.Labels, map_1((labelId) => (new LabelId(parse(labelId))), props.Set.LabelIds)),
                                    OnSetCustomProperty: (arg_14) => {
                                        props.Dispatch(new Msg(9, [arg_14]));
                                    },
                                    PropertyConfigurations: props.PropertyConfigurations,
                                })),
                                Header: Header_4,
                                Id: "custom_properties",
                            }))) : empty_1(), delay(() => {
                                let matchValue_6;
                                return append((matchValue_6 = FormState__getValidation(props.FormState, t, "global"), (matchValue_6 == null) ? (empty_1()) : singleton_1(createElement(ErrorAlert, {
                                    Label: matchValue_6,
                                }))), delay(() => {
                                    let elems_2;
                                    return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_2 = [createElement(Button, {
                                        ComponentState: componentState,
                                        Label: t("general.save"),
                                        OnClick: props.OnSave,
                                        TestId: "tool-form-save-button",
                                        Variant: "primary",
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function EditSetView(props) {
    let elems_1, elems, Label;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initEditView(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.UserData, props.SetId], undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.SetForm;
    const matchValue_1 = state_1.Tools;
    const matchValue_2 = state_1.Storages;
    const matchValue_3 = state_1.Labels;
    const matchValue_4 = state_1.PropertyConfigurations;
    const matchValue_5 = state_1.IsCustomPropertiesEnabled;
    const matchValue_6 = state_1.BusinessUnits;
    const matchValue_7 = state_1.AccountSettings;
    const matchValue_8 = state_1.UserData;
    let matchResult, accountSettings, businessUnits, isPropertyConfigurationsEnabled, labels, propertyConfigurations, set$, storages, tools, userData_1;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_7.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_8 == null) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_7.fields[0];
        businessUnits = matchValue_6.fields[0];
        isPropertyConfigurationsEnabled = matchValue_5.fields[0];
        labels = matchValue_3.fields[0];
        propertyConfigurations = matchValue_4.fields[0];
        set$ = matchValue.fields[0];
        storages = matchValue_2.fields[0];
        tools = matchValue_1.fields[0];
        userData_1 = matchValue_8;
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3", "flex"])], (elems = [createElement(TextButton, (Label = patternInput_1[0]("general.back"), {
                ComponentState: "enabled",
                Icon: Arrow_Left_1(),
                Label: Label,
                OnClick: () => {
                    RouterModule_nav(ofArray(["sets", SetId__get_unwrap(props.SetId) + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                },
                TestId: "set-new-back-to-overview-button",
                Variant: "default",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(PageHeader, {
                Text: "set.form.edit_title",
            }), createElement(SetForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                IsCustomPropertiesEnabled: isPropertyConfigurationsEnabled && !isEmpty(propertyConfigurations),
                IsEdit: true,
                IsVisibleForUser: true,
                Labels: labels,
                OnSave: () => {
                    dispatch(new Msg(24, []));
                },
                PropertyConfigurations: propertyConfigurations,
                PurchaseDate: unwrap(state_1.PurchaseDate),
                Set: set$,
                SetImages: state_1.SetImages,
                State: state_1,
                Storages: storages,
                Tools: tools,
                UserData: userData_1,
                WarrantyDate: unwrap(state_1.WarrantyDate),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        default:
            return createElement(Skeleton, {
                Variant: "normal",
            });
    }
}

export function NewSetView(props) {
    let elems_1, elems, Label;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNewSetView, update_1, (_arg, _arg_1) => {
    }), props.UserData, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.SetForm;
    const matchValue_1 = state_1.Tools;
    const matchValue_2 = state_1.Storages;
    const matchValue_3 = state_1.Labels;
    const matchValue_4 = state_1.PropertyConfigurations;
    const matchValue_5 = state_1.IsCustomPropertiesEnabled;
    const matchValue_6 = state_1.BusinessUnits;
    const matchValue_7 = state_1.AccountSettings;
    const matchValue_8 = state_1.UserData;
    let matchResult, accountSettings, businessUnits, isPropertyConfigurationsEnabled, labels, propertyConfigurations, set$, storages, tools, userData_1;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_7.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_8 == null) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_7.fields[0];
        businessUnits = matchValue_6.fields[0];
        isPropertyConfigurationsEnabled = matchValue_5.fields[0];
        labels = matchValue_3.fields[0];
        propertyConfigurations = matchValue_4.fields[0];
        set$ = matchValue.fields[0];
        storages = matchValue_2.fields[0];
        tools = matchValue_1.fields[0];
        userData_1 = matchValue_8;
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3", "flex"])], (elems = [createElement(TextButton, (Label = patternInput_1[0]("general.back_to_overview"), {
                ComponentState: "enabled",
                Icon: Arrow_Left_1(),
                Label: Label,
                OnClick: () => {
                    RouterModule_nav(singleton("tools" + RouterModule_encodeQueryString(getQueryParams(undefined))), 1, 1);
                },
                TestId: "set-new-back-to-overview-button",
                Variant: "default",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(PageHeader, {
                Text: "set.form.create_title",
            }), createElement(SetForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                IsCustomPropertiesEnabled: isPropertyConfigurationsEnabled && !isEmpty(propertyConfigurations),
                IsEdit: false,
                IsVisibleForUser: true,
                Labels: labels,
                OnSave: () => {
                    dispatch(new Msg(23, []));
                },
                PropertyConfigurations: propertyConfigurations,
                PurchaseDate: unwrap(state_1.PurchaseDate),
                Set: set$,
                SetImages: state_1.SetImages,
                State: state_1,
                Storages: storages,
                Tools: tools,
                UserData: userData_1,
                WarrantyDate: unwrap(state_1.WarrantyDate),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        default:
            return createElement(Skeleton, {
                Variant: "normal",
            });
    }
}

export function CopySetView(props) {
    let elems_1, elems, Label;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initCopySetView(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.UserData, props.SetId], undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.SetForm;
    const matchValue_1 = state_1.Tools;
    const matchValue_2 = state_1.Storages;
    const matchValue_3 = state_1.Labels;
    const matchValue_4 = state_1.PropertyConfigurations;
    const matchValue_5 = state_1.IsCustomPropertiesEnabled;
    const matchValue_6 = state_1.BusinessUnits;
    const matchValue_7 = state_1.AccountSettings;
    const matchValue_8 = state_1.UserData;
    let matchResult, accountSettings, businessUnits, isPropertyConfigurationsEnabled, labels, propertyConfigurations, set$, storages, tools, userData_1;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_7.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_8 == null) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_7.fields[0];
        businessUnits = matchValue_6.fields[0];
        isPropertyConfigurationsEnabled = matchValue_5.fields[0];
        labels = matchValue_3.fields[0];
        propertyConfigurations = matchValue_4.fields[0];
        set$ = matchValue.fields[0];
        storages = matchValue_2.fields[0];
        tools = matchValue_1.fields[0];
        userData_1 = matchValue_8;
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3", "flex"])], (elems = [createElement(TextButton, (Label = patternInput_1[0]("general.back"), {
                ComponentState: "enabled",
                Icon: Arrow_Left_1(),
                Label: Label,
                OnClick: () => {
                    RouterModule_nav(ofArray(["sets", SetId__get_unwrap(props.SetId) + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                },
                TestId: "set-new-back-to-overview-button",
                Variant: "default",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(PageHeader, {
                Text: "set.form.create_title",
            }), createElement(SetForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                IsCustomPropertiesEnabled: isPropertyConfigurationsEnabled && !isEmpty(propertyConfigurations),
                IsEdit: false,
                IsVisibleForUser: true,
                Labels: labels,
                OnSave: () => {
                    dispatch(new Msg(23, []));
                },
                PropertyConfigurations: propertyConfigurations,
                PurchaseDate: unwrap(state_1.PurchaseDate),
                Set: set$,
                SetImages: state_1.SetImages,
                State: state_1,
                Storages: storages,
                Tools: tools,
                UserData: userData_1,
                WarrantyDate: unwrap(state_1.WarrantyDate),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        default:
            return createElement(Skeleton, {
                Variant: "normal",
            });
    }
}

